import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from '@sentry/browser';
import "./index.css";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { Provider } from "react-redux";
import { store } from './store';
import { Amplify } from "aws-amplify";
import { configureAutoTrack } from "aws-amplify/analytics";
import {amplifyConfig, apiExtras} from './amplifyconfiguration.js'
import App from "./App";
import { ErrorBoundary } from "./components/Common/ErrorBoundary";
import theme from "./theme/theme";

// SENTRY INIT
Sentry.init({
  dsn: "https://ded22177f03b49b4891ddaad28357a84@o341614.ingest.sentry.io/5271094",
  release:
    process.env.REACT_APP_STAGE +
    "@" +
    process.env.REACT_APP_VERSION +
    (process.env.REACT_APP_BUILD
      ? "." + parseInt(process.env.REACT_APP_BUILD, 10)
      : ""),
      environment: process.env.REACT_APP_STAGE
});

Amplify.configure(amplifyConfig, apiExtras);

// 1. PageView Tracking Configuration
configureAutoTrack({
  enable: true, 
  type: 'pageView', 
  options: {
    pageView: {
      type: 'SPA' 
    }
  }
});

// // 2. Session Tracking Configuration (Explicitly ensuring it's enabled)
configureAutoTrack({
  enable: true, 
  type: 'session',
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // You may want to re-enable StrictMode later to catch potential issues
  // <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ErrorBoundary>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ErrorBoundary>
      </ThemeProvider>
    </Provider>
  // </React.StrictMode>
);